import { defineMessages } from 'react-intl';

export default defineMessages({
  editButtonText: {
    description: 'Text displayed to the user to describe the edit button',
    defaultMessage: 'Edit',
    id: 'hpyMqL',
  },
  duplicateShopperButtonText: {
    description: 'Text displayed to the user to describe the duplicate shopper button',
    defaultMessage: 'Duplicate',
    id: 'rAYUc9',
  },
  copyAddendumText: {
    description: 'Text displayed to the user when a shopper is duplicated',
    defaultMessage: '{name} (copy)',
    id: 'aYNUjy',
  },
  createRuleButtonText: {
    description: 'Text displayed to the user to create a new rule',
    defaultMessage: 'Create Automation Rule',
    id: 'AeZIQ7',
  },
  newRuleName: {
    description: 'Default name for a new rule',
    defaultMessage: 'New Rule',
    id: '6qsW35',
  },
});
